import {getPMSClient} from '../..'
import {createFetchActions} from '../../services/createActions'
import {dashboardEntityAmountQuery, dashboardPortfolioAnalyticsQuery} from './repoQueries'

export const SET_REPO_CLICKED_PORTFOLIO_ENTITY = 'SET_REPO_CLICKED_PORTFOLIO_ENTITY'
export const SET_REPO_CLICKED_GROUPBY_ENTITY = 'SET_REPO_CLICKED_GROUPBY_ENTITY'
export const SET_CLICKED_FIRST_LEVEL_TREEMAP_VALUE = 'SET_CLICKED_FIRST_LEVEL_TREEMAP_VALUE'
export const SET_CLICKED_SECOND_LEVEL_TREEMAP_VALUE = 'SET_CLICKED_SECOND_LEVEL_TREEMAP_VALUE'
export const GET_CLICKED_PORTFOLIO_ENTITY = createFetchActions('GET_CLICKED_PORTFOLIO_ENTITY')
export const GET_CLICKED_GROUPBY_ENTITY = createFetchActions('GET_CLICKED_GROUPBY_ENTITY')
export const RESET_DASHBOARD_DATA = 'RESET_DASHBOARD_DATA'
export const GET_REPO_ENTITIES_AMOUNT = createFetchActions('GET_REPO_ENTITIES_AMOUNT')
export const GET_REPO_PORTFOLIO_ANALYTICS = createFetchActions('GET_DASHBOARD_PORTFOLIO_ANALYTICS')
export const GET_PORTFOLIO_UPLOADED_DATE = createFetchActions('GET_PORTFOLIO_UPLOADED_DATE')
export const GET_PORTFOLIO_DOCS_INCLUDED = createFetchActions('GET_PORTFOLIO_DOCS_INCLUDED')
export const SET_REPO_TOGGLE_INDEX = createFetchActions('SET_REPO_TOGGLE_INDEX')
export const SET_REPO_DRILLDOWNN = createFetchActions('SET_REPO_DRILLDOWNN')

export const setClickedPortfolioEntity = data => {
	return {
		type: SET_REPO_CLICKED_PORTFOLIO_ENTITY,
		response: {
			data: data,
		},
	}
}

export const setClickedFirstLevelTreemapValue = data => {
	return {
		type: SET_CLICKED_FIRST_LEVEL_TREEMAP_VALUE,
		response: {
			data: data,
		},
	}
}

export const setClickedSecondLevelTreemapValue = data => {
	return {
		type: SET_CLICKED_SECOND_LEVEL_TREEMAP_VALUE,
		response: {
			data: data,
		},
	}
}

export const setClickedGroupByEntity = (name, groupOne, groupTwo) => {
	return {
		type: SET_REPO_CLICKED_GROUPBY_ENTITY,
		response: {
			groupEntityname: name,
			groupOne,
			groupTwo,
		},
	}
}

export const setToggleActiveIndex = (name: string, index: number) => {
	return {
		type: SET_REPO_TOGGLE_INDEX,
		response: {
			toggleName: name,
			index,
		},
	}
}

export const setDrilldown = (name?: string, drilldownData?: Object) => {
	return {
		type: SET_REPO_DRILLDOWNN,
		response: {
			drilldownName: name,
			drilldownData,
		},
	}
}

export function getDashboardEntitiesAmount() {
	return function (dispatch) {
		dispatch({
			type: GET_REPO_ENTITIES_AMOUNT.triggered,
		})

		getPMSClient()
			.query({
				query: dashboardEntityAmountQuery,
				fetchPolicy: 'network-only',
			})
			.then(response => {
				dispatch({
					type: GET_REPO_ENTITIES_AMOUNT.succeeded,
					response,
				})
			})
	}
}

const executeFirstPortfolioQuery = firstPortfolioQuery => {
	if (!firstPortfolioQuery) return null
	return getPMSClient()
		.query({
			query: firstPortfolioQuery,
			fetchPolicy: 'network-only',
		})
		.then(response => {
			return response.data
		})
		.catch(error => {
			return null
		})
}

const executeSecondPortfolioQuery = secondPortfolioQuery => {
	if (!secondPortfolioQuery) return null
	return getPMSClient()
		.query({
			query: secondPortfolioQuery,
			fetchPolicy: 'network-only',
		})
		.then(response => {
			return response.data
		})
		.catch(error => {
			return null
		})
}

export const getDashboardPortfolioAnalytics = portfolioQueryType => {
	return function (dispatch) {
		dispatch({
			type: GET_REPO_PORTFOLIO_ANALYTICS.triggered,
		})

		const firstPortfolioQuery =
			Array.isArray(portfolioQueryType) &&
			portfolioQueryType.length > 0 &&
			dashboardPortfolioAnalyticsQuery[portfolioQueryType[0]]
		const secondPortfolioQuery =
			Array.isArray(portfolioQueryType) &&
			portfolioQueryType.length === 2 &&
			dashboardPortfolioAnalyticsQuery[portfolioQueryType[1]]

		Promise.all([
			executeFirstPortfolioQuery(firstPortfolioQuery),
			executeSecondPortfolioQuery(secondPortfolioQuery),
		]).then(combinedResponse =>
			dispatch({
				type: GET_REPO_PORTFOLIO_ANALYTICS.succeeded,
				response: [{[portfolioQueryType[0]]: combinedResponse[0]}, {[portfolioQueryType[1]]: combinedResponse[1]}],
			})
		)
	}
}

export const resetDashboardData = () => {
	return {
		type: RESET_DASHBOARD_DATA,
	}
}
